import React from 'react';
import styled from '@emotion/styled';
import { colors } from 'src/theme';

interface PropertyTypeButtonProps {
  icon: React.ReactNode;
  text: string;
  selected?: boolean;
  onClick?: () => void;
  className?: string;
}

const ButtonContainer = styled.button<{ selected: boolean }>(props => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  width: '100%',
  height: '88px',
  padding: '8px 14px',
  backgroundColor: colors.background6,
  border: props.selected ? `2px solid ${colors.primary}` : '2px solid transparent',
  borderRadius: '8px',
  cursor: 'pointer',
  transition: 'all 0.15s ease-in-out',
  overflow: 'hidden',
  
  '&:hover': {
    borderColor: colors.primary,
    backgroundColor: colors.primary,

    '& svg path': {
      stroke: 'white',
    },
    '& p': {
      color: 'white',
    },
  },

  '&:active': {
    transform: 'scale(0.98)'
  }
}));

const IconWrapper = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '32px',
  height: '32px',
  transition: 'color 0.15s ease-in-out',
});

const ButtonText = styled.p<{ selected: boolean }>(props => ({
  fontFamily: "'Red Hat Text', sans-serif",
  fontSize: '18px',
  fontWeight: 700,
  lineHeight: '20px',
  color: props.selected ? colors.primary : colors.text2,
  margin: 0,
  transition: 'color 0.15s ease-in-out',
}));

export const PropertyTypeButton: React.FC<PropertyTypeButtonProps> = ({ 
  icon, 
  text, 
  selected = false, 
  onClick,
  className 
}) => {
  return (
    <ButtonContainer 
      selected={selected} 
      onClick={onClick}
      className={className}
      type="button"
    >
      <IconWrapper>{icon}</IconWrapper>
      <ButtonText selected={selected}>{text}</ButtonText>
    </ButtonContainer>
  );
};
